import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45entry_45redirect_45global from "/app/apps/main/middleware/00.entry-redirect.global.ts";
import _01_45auth_45global from "/app/apps/main/middleware/01.auth.global.ts";
import _02_45access_45global from "/app/apps/main/middleware/02.access.global.ts";
import _03_45client_45global from "/app/apps/main/middleware/03.client.global.ts";
import _04_45country_45global from "/app/apps/main/middleware/04.country.global.ts";
import i18n_45global from "/app/apps/main/middleware/i18n.global.ts";
import social_45auth_45analytics_45global from "/app/apps/main/middleware/social-auth-analytics.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _00_45entry_45redirect_45global,
  _01_45auth_45global,
  _02_45access_45global,
  _03_45client_45global,
  _04_45country_45global,
  i18n_45global,
  social_45auth_45analytics_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}